import { Injectable } from '@angular/core';
import { WrapperService } from './wrapper.service';

import { RegisterCompanyRequest, RegisterUserRequest, RegisterTaxpayerRequest } from 'src/app/models/account';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService extends WrapperService {

  generateToken(param: any) {
    return this.post("/api/v1/auth/generate-token", param)
  }

  submitCompanyData(
    officeID: string,
    params: RegisterCompanyRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    let latitude;
    let longitude;
    let coordinate = params.coordinate.split(",");
    if(coordinate.length === 2) {
      latitude = coordinate[0];
      longitude = coordinate[1];
    }

    const formData = new FormData();
    if (officeID) {
      formData.append("officeId", officeID);
    }
    formData.append("businessType", params.business_type_code);
    formData.append("businessName", params.business_name);
    formData.append("province", params.province_id);
    formData.append("city", params.regency_id);
    formData.append("district", params.district_id);
    formData.append("village", params.village_id);
    formData.append("postCode", params.postal_code);
    formData.append("long", longitude);
    formData.append("lat", latitude);
    formData.append("frontLook", params.image);
    formData.append("address", params.business_address);
    formData.append("rt", params.neighbourhood || "");
    formData.append("rw", params.hamlet || "");
    this.postMultipartFormData('/api/v1/register/store-member-office', formData)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  submitUserData(
    officeID: string,
    memberID: string,
    params: RegisterUserRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    const formData = new FormData();
     if (memberID) {
      formData.append("memberId", memberID);
    }
    formData.append("officeId", officeID);
    formData.append("email", params.email);
    formData.append("phoneNumber", params.phone_number);
    formData.append("name", params.name);
    formData.append("ktpNo", params.ktp_number);
    formData.append("ktp", params.ktp_file);
    this.postMultipartFormData('/api/v1/register/store-member', formData)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  submitShippingAddressData(
    params: any,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    const formData = new FormData();
    if (params.memberId) {
      formData.append("memberId", params.memberId);
    }
    if (params.shippingAddressId) {
      formData.append("shippingAddressId", params.shippingAddressId);
    }
    if (params.warehouseLicenseFile) {
      formData.append("suratIzinGudang", params.warehouseLicenseFile);
    }
    formData.append("province", params.province);
    formData.append("city", params.city);
    formData.append("district", params.district);
    formData.append("village", params.village);
    formData.append("postCode", params.postCode);
    formData.append("long", params.long);
    formData.append("lat", params.lat);
    formData.append("address", params.address);
    formData.append("rt", params.rt || "");
    formData.append("rw", params.rw || "");

    this.postMultipartFormData('/api/v1/register/store-shipping-address', formData)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  submitTaxpayerData(
    memberID: string,
    params: RegisterTaxpayerRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    let hasNpwp = params.has_npwp ? "1":"2";
    let isNonPkp = params.is_non_pkp ? "2":"1";
    const formData = new FormData();
    formData.append("isNpwp", hasNpwp);
    formData.append("memberId", memberID);
    if (params.has_npwp) {
      formData.append("npwpNo", params.npwp_number);
      formData.append("taxpayerName", params.name);
      formData.append("taxpayerAddress", params.address);
      formData.append("npwp", params.file);
      formData.append("isPkp", isNonPkp);
      if (!params.is_non_pkp) {
        formData.append("spPkp", params.sppkp_file);
      }
    }
    if (!params.has_npwp) {      
      formData.append("npwpReplacementCert", params.statement_file);
    }
    this.postMultipartFormData('/api/v1/register/store-taxpayer', formData)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  checkKTPNumber(
    memberID: string,
    ktpNumber: string,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.post('/api/v1/register/check-ktp', {
      "ktpNo": ktpNumber,
      "memberId": memberID,
    })
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }
}
